<template>
  <b-col class="col-sm-12 mx-auto p-3">
    <h3
      class="mb-3"
    >Your email has been verified. Please click the button to continue setting up your profile. Note: You may be prompted to login</h3>
    <b-button
      variant="primary"
      size="lg"
      class="mb-3 mr-3"
      :to="{name: 'setupUser', params:{id: $route.params.id}}"
    >Setup my profile</b-button>
  </b-col>
</template>
<script>
  import Auth from '@/fstore/auth';
  import User from '@/fstore/collections/User';
  
  export default {
    data() {
      return {
        user: null
      }
    },
    async created () {
      this.user = await User.getById(this.$route.params.id);

      if(!this.user) {
        return;
      }

      await User.verify(this.$route.params.id)

      await Auth.logout();
    }
  }
</script>